// extracted by mini-css-extract-plugin
export default {"Container":"lightTextInput__Container__HDwBn","Input":"lightTextInput__Input__NoeJ0","Label":"lightTextInput__Label__D3P4n","Hover":"lightTextInput__Hover__cjY1f"};